import ApiService from '@/services/core/api.service'

const RegionService = {
  async get (query) {
    return ApiService.get(`admin/regions?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/regions', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/regions/${payload.id}`, payload)
  }
}

export default RegionService
